/* -----------------UI--------------- */
import { Redirect } from "expo-router";

/* -----------------Helpers & Hooks--------------- */
import { useDevice } from "@hooks/useDevice";

import { useUser } from "@clerk/clerk-expo";
import { DEMO_EXAMS } from "@constants/demo/common";
/* -----------------Types--------------- */
import { AppBottomTabs, AppDrawer } from "@features/dashboard/";
import { useProethicaSessionSync } from "@features/session/hooks/useProethicaSessionSync";
import { isWeb } from "@helpers/platform";
import { useDemoExamStore } from "@hooks/useDemoExamStore";
import { useEffect } from "react";

const DashboardLayout = () => {
	const { isMobile, isMediumWindowSize } = useDevice();
	const { isSignedIn, isLoaded } = useUser();

	const setDemoExams = useDemoExamStore((state) => state.setDemoExams);

	useProethicaSessionSync();

	useEffect(() => {
		setDemoExams(DEMO_EXAMS);
	}, [setDemoExams]);

	if (!(isSignedIn || isLoaded)) {
		return <Redirect href="/" />;
	}

	return (
		<>
			{(isMobile || isMediumWindowSize) && !isWeb ? (
				<AppBottomTabs />
			) : (
				<AppDrawer />
			)}
		</>
	);
};

export default DashboardLayout;
